import FacebookDark from "./FacebookDark.png";
import InstagramDark from "./InstagramDark.png";
import TelegramDark from "./TelegramDark.png";
import GithubDark from "./GithubDark.png";
import LinkedinDark from "./LinkedinDark.png";
import BehanceDark from "./BehanceDark.png";
import FacebookLight from "./FacebookLight.png";
import InstagramLight from "./InstagramLight.png";
import TelegramLight from "./TelegramLight.png";
import GithubLight from "./GithubLight.png";
import LinkedinLight from "./LinkedinLight.png";
import BehanceLight from "./BehanceLight.png";

const SocmedImages = {
  FacebookDark: FacebookDark,
  InstagramDark: InstagramDark,
  TelegramDark: TelegramDark,
  GithubDark: GithubDark,
  LinkedinDark: LinkedinDark,
  BehanceDark: BehanceDark,
  FacebookLight: FacebookLight,
  InstagramLight: InstagramLight,
  TelegramLight: TelegramLight,
  GithubLight: GithubLight,
  LinkedinLight: LinkedinLight,
  BehanceLight: BehanceLight,
};

export default SocmedImages;
